import { dateTimeFormat } from '@/utility/utility_functions'
import State from './State'

export default class SmsLog {
  constructor (id, created, receiver, sender, message, status, customerCase) {
    this.id = id
    this.created = created
    this.receiver = receiver
    this.sender = sender
    this.message = message
    this.status = status
    this.customer_case = customerCase
  }

  static asSmsLogs (json) {
    return json.map(smsLog => {
      return SmsLog.asSmsLog(smsLog)
    })
  }

  static asSmsLog (json) {
    return new SmsLog(
      json.id,
      json.created ? dateTimeFormat(json.created) : '',
      json.receiver,
      json.sender.get_full_name ? json.sender.get_full_name : '',
      json.message,
      json.status,
      json.case ? json.case : ''
    )
  }
  get statusResult () {
    return {
      display: this.status === 200 ? 'Ok' : 'Error',
      level: this.status === 200 ? State.SUCCESS : State.DANGER,
      custom_classes: ['tag-flex']
    }
  }
}
